"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuButtonWrapper = _styledComponents.default.a.attrs({
  "data-qa": "menu-button-wrapper"
}).withConfig({
  displayName: "MenuButton__MenuButtonWrapper",
  componentId: "sc-1o5ke93-0"
})(["align-items:center;color:", ";display:inline-flex;font-family:", ";font-size:14px;font-weight:700;justify-content:center;text-decoration:none;text-transform:uppercase;white-space:nowrap;letter-spacing:0.34px;cursor:pointer;&:hover{color:", ";text-decoration:none;}"], function (props) {
  return props.theme.carvana.blue.dark;
}, function (props) {
  return props.theme.typography.fontFamily;
}, function (props) {
  return props.theme.carvana.blue.primary;
});

var handleClick = function handleClick(e, href, onClick, eventName, disableHref) {
  onClick(e);
  var shouldPreventDefault = href === '' || disableHref;

  if (shouldPreventDefault) {
    e.preventDefault();
  }
};

var handleTouchStart = function handleTouchStart(e, href, onTouchStart, disableHref) {
  onTouchStart(e);
  var shouldPreventDefault = href === '' || disableHref;

  if (shouldPreventDefault) {
    e.preventDefault();
  }
};

var MenuButton = function MenuButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      dataCvTest = _ref.dataCvTest,
      eventName = _ref.eventName,
      href = _ref.href,
      target = _ref.target,
      _onClick = _ref.onClick,
      _onTouchStart = _ref.onTouchStart,
      disableHref = _ref.disableHref,
      isInDotCom = _ref.isInDotCom;
  var dotComTarget = isInDotCom ? '_self' : null;
  var nextTarget = target || dotComTarget;
  return _react.default.createElement(MenuButtonWrapper, Object.assign({
    className: className,
    "data-cv-test": dataCvTest,
    eventName: eventName,
    href: href
  }, nextTarget && {
    target: nextTarget
  }, {
    onClick: function onClick(e) {
      return handleClick(e, href, _onClick, eventName, disableHref);
    },
    onTouchStart: function onTouchStart(e) {
      return handleTouchStart(e, href, _onTouchStart, disableHref);
    },
    "data-qa": "menu-button"
  }), children);
};

MenuButton.defaultProps = {
  className: '',
  dataCvTest: '',
  eventName: '',
  href: '',
  target: null,
  onClick: function onClick() {
    return null;
  },
  onTouchStart: function onTouchStart() {
    return null;
  },
  disableHref: false
};
var _default = MenuButton;
exports.default = _default;
module.exports = exports.default;